import { useTheme } from '@nfinite/react-hubstairs/styled/theme'
import { useRef } from 'react'
import StackGrid from 'components/Commons/Masonry'
import useResizeObserver from '@nfinite/react-hubstairs/hooks/useResizeObserver'

export const TEMPLATE = {
  SMALL: { xxs: 1, xs: 1, sm: 1, md: 2, lg: 2, xl: 3, xxl: 3, xxxl: 4, xxxxl: 6 },
  MEDIUM: { xxs: 1, xs: 1, sm: 2, md: 2, lg: 3, xl: 3, xxl: 3, xxxl: 4, xxxxl: 5 },
  LARGE: { xxs: 2, xs: 2, sm: 3, md: 3, lg: 4, xl: 4, xxl: 4, xxxl: 4, xxxxl: 5 },
  EXTRA_LARGE: { xxs: 2, xs: 2, sm: 3, md: 4, lg: 5, xl: 6, xxl: 6, xxxl: 8, xxxxl: 8 },
}

function MasonicCard({ data, index, placeholder, render }) {
  if (data.empty) return <div style={{ height: 0, width: 0 }} />
  if (data.placeholder) return placeholder
  if (data.customElement) return data.customElement
  return render({ data, index })
}

function useColumnCount({ itemsPerRow, template, columnWidth, gridWidth }) {
  const theme = useTheme()
  const actualBreakpoint = theme.getActualBreakpoint()

  if (itemsPerRow) return itemsPerRow

  if (template) {
    return template[actualBreakpoint] || template.xxs || 1
  }

  if (!gridWidth || !columnWidth) return 1

  return Math.max(Math.floor(gridWidth / columnWidth), 1)
}

function useColumnWidth({ itemsPerRow, template, columnWidth, gridWidth }) {
  const columnCount = useColumnCount({ itemsPerRow, template, columnWidth, gridWidth })
  return `${(100 / columnCount).toFixed(2)}%`
}

function MasonryList({
  items,
  placeholders = [],
  columnGutter = 20,
  columnWidth = 360,
  itemsPerRow,
  template,
  render,
  placeholder,
  observeItemResize = false,
}) {
  const ref = useRef()
  const { width: gridWidth } = useResizeObserver(ref)

  const list = items.concat(placeholders)
  const columnWidthPercent = useColumnWidth({ itemsPerRow, template, columnWidth, gridWidth })

  return (
    <div ref={ref} style={{ width: '100%' }}>
      {gridWidth === 0 ? null : (
        <StackGrid
          columnWidth={columnWidthPercent}
          gutterWidth={columnGutter}
          gutterHeight={columnGutter}
          itemComponent="div"
          observeItemResize={observeItemResize}
        >
          {list.map((data, index) => (
            <MasonicCard
              key={data.id + index}
              monitorImagesLoaded={false}
              data={data}
              index={index}
              placeholder={placeholder}
              render={render}
            />
          ))}
        </StackGrid>
      )}
    </div>
  )
}

export default MasonryList
